import { api } from './client.js';

const root = '/admin/logistics';

export const logisticsApi = {
  listTransfers: (params) => api.get(`${root}/transfers`, { query: params }),
  getTransfer: (id) => api.get(`${root}/transfers/${id}`),
  createTransfer: (body) => api.post(`${root}/transfers`, body),
  shipTransfer: (id) => api.post(`${root}/transfers/${id}/ship`),
  receiveTransfer: (id, body) => api.post(`${root}/transfers/${id}/receive`, body || {}),
  cancelTransfer: (id) => api.post(`${root}/transfers/${id}/cancel`),

  listLoads: (params) => api.get(`${root}/loads`, { query: params }),
  getLoad: (id) => api.get(`${root}/loads/${id}`),
  createLoad: (body) => api.post(`${root}/loads`, body),
  updateLoad: (id, body) => api.patch(`${root}/loads/${id}`, body),
  confirmLoad: (id) => api.post(`${root}/loads/${id}/confirm`),
  cancelLoad: (id) => api.post(`${root}/loads/${id}/cancel`),
  removeLoad: (id) => api.delete(`${root}/loads/${id}`),

  listMovements: (params) => api.get(`${root}/stock-movements`, { query: params })
};
